export class PatientStatusModel{
    id:number;
    patientStatus:string;
    isActive: any;
}
